import { cn } from "@/lib/cn"
import { BRAND } from "./brand.config"
import { maskStyle } from "./mask"

/** Splits the name so the configured accent ("SMS") can be drawn in primary. */
function splitName(): [string, string] {
  const accent = BRAND.wordmarkAccent
  if (!accent || !BRAND.name.endsWith(accent)) return [BRAND.name, ""]
  return [BRAND.name.slice(0, -accent.length), accent]
}

/**
 * The sidebar header / auth-screen wordmark: the mark, painted with the
 * primary token so it lifts with the theme, then the name with its accent.
 * Never a broken image, never blank: a configured logo image replaces both,
 * otherwise the plain name always renders.
 */
export function Wordmark({ className, size = "sm" }: { className?: string; size?: "sm" | "lg" }) {
  if (BRAND.logoAssetPath) {
    return <img src={BRAND.logoAssetPath} alt={BRAND.name} className={className} />
  }
  const [lead, accent] = splitName()
  return (
    <span className={cn("inline-flex items-center gap-2", className)}>
      {BRAND.markAssetPath ? (
        <span
          data-brand-mark=""
          aria-hidden="true"
          className={cn("shrink-0 bg-primary", size === "lg" ? "size-7" : "size-5")}
          style={maskStyle(BRAND.markAssetPath)}
        />
      ) : null}
      <span className="truncate">
        {lead}
        {accent ? <span className="text-primary">{accent}</span> : null}
      </span>
    </span>
  )
}
